// The company that owns and operates Meu Treino (the same holding owns OdeParfum; keep both in sync).
// Used by the Terms of Use, the Privacy Policy and the footer.
export const COMPANY = {
  legalName: 'CLAUDIO PIPE LTDA',
  cnpj: '66.285.364/0001-73',
  address: 'Rua Mostardeiro, 777, Sala 1401, Rio Branco, Porto Alegre/RS, CEP 90430-001',
};

// Interpolation values for the legal copy in the locale files
export const COMPANY_VARS = {
  companyName: COMPANY.legalName,
  cnpj: COMPANY.cnpj,
  address: COMPANY.address,
};

/** Numbered list keys of a legal section: listKeys('s2Item', 3) → ['s2Item1', 's2Item2', 's2Item3'] */
export const listKeys = (prefix, count) =>
  Array.from({ length: count }, (_, index) => `${prefix}${index + 1}`);
